/**
 * 授权功能判断（私有化 License）
 *
 * 点号层级 + 祖先覆盖：授权一级（如 "tools"）自动覆盖其二级（"tools.review"）；
 * features 为空 / null 视为不限制（未授权或未配置 features 时放行，由后端做最终拦截）。
 *
 * 与后端 license_service.feature_allowed / license::feature_allowed 逻辑一致。
 */
export function hasFeature(features: string[] | null | undefined, feature: string): boolean {
  if (!features || features.length === 0) return true;
  if (features.includes(feature)) return true;
  const parts = feature.split('.');
  for (let i = 1; i < parts.length; i++) {
    if (features.includes(parts.slice(0, i).join('.'))) return true;
  }
  return false;
}
